import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ScanLine, X } from 'lucide-react';

const KEY = 'eventism_scanner_return';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function rememberScannerSession(eventId, eventName) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ eventId, eventName: eventName || '', ts: Date.now() }));
  } catch (e) { /* storage unavailable */ }
}

export default function ScannerReturnPill() {
  const location = useLocation();
  const navigate = useNavigate();
  const [session, setSession] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) { setSession(null); return; }
      const s = JSON.parse(raw);
      if (!s.eventId || Date.now() - (s.ts || 0) > MAX_AGE_MS) {
        localStorage.removeItem(KEY);
        setSession(null);
        return;
      }
      setSession(s);
    } catch (e) { setSession(null); }
  }, [location.pathname]);

  if (!session || location.pathname.startsWith('/admin/checkin/')) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-1 rounded-full bg-emerald-600 text-white shadow-lg shadow-emerald-900/40 pl-4 pr-1.5 py-1.5" data-testid="scanner-return-pill">
      <button
        onClick={() => navigate(`/admin/checkin/${session.eventId}`)}
        className="flex items-center gap-2 text-sm font-semibold"
        data-testid="scanner-return-btn"
      >
        <ScanLine className="h-4 w-4" />
        Back to scanning{session.eventName ? ` — ${session.eventName.slice(0, 24)}` : ''}
      </button>
      <button
        onClick={() => { localStorage.removeItem(KEY); setSession(null); }}
        className="p-1.5 rounded-full hover:bg-emerald-700"
        aria-label="Dismiss"
        data-testid="scanner-return-dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
